import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import type { User } from "@shared/types";
import { api } from "./lib/api";

interface AuthContextValue {
  user: User | null;
  loading: boolean;
  refresh(): Promise<void>;
  login(email: string, password: string): Promise<void>;
  register(input: { name: string; email: string; password: string; age?: number; targetLanguage?: string; level?: string }): Promise<void>;
  logout(): Promise<void>;
  setUser(user: User): void;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUserState] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const refresh = async () => {
    try { const result = await api<{ user: User }>("/api/auth/me"); setUserState(result.user); }
    catch { setUserState(null); }
    finally { setLoading(false); }
  };
  useEffect(() => { void refresh(); }, []);
  const login = async (email: string, password: string) => { const result = await api<{ user: User }>("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password }) }); setUserState(result.user); };
  const register = async (input: any) => { const result = await api<{ user: User }>("/api/auth/register", { method: "POST", body: JSON.stringify(input) }); setUserState(result.user); };
  const logout = async () => { await api("/api/auth/logout", { method: "POST" }); setUserState(null); };
  return <AuthContext.Provider value={{ user, loading, refresh, login, register, logout, setUser: setUserState }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth precisa estar dentro de AuthProvider");
  return value;
}
